// -*- mode: rjsx -*-
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, unwrapResult } from 'react-redux';

import { List } from "./List.jsx";
// import { fetchUnclaimed } from '../../request';

import { selectCallRequests, loadQueue } from '../../queue';

function UnclaimedCallList(props) {
    
    const dispatch = useDispatch();
    const tasks = useSelector(selectCallRequests);
/*
	useEffect(() => {
		dispatch(loadQueue());
    }, [dispatch]);
*/		

	return <List tasks={tasks}  queue={props.queue} />;
}

export { UnclaimedCallList };


